import { Injectable } from '@angular/core';
import { Analytics, getAnalytics, logEvent, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { ThirdPartyEventType } from '../../types/event.type';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';

@Injectable({
  providedIn: 'root',
})
export class FirebaseAnalyticsService {
  constructor(private angularFireAnalytics: AngularFireAnalytics) {}

  init() {}

  logEvent(eventType: ThirdPartyEventType, params: object) {
    try {
      this.angularFireAnalytics
        .logEvent(eventType.toString(), params)
        .then(() => {
          // todo ruan new debug mode
          //   console.log(`✅ Event logged successfully: ${eventType}`);
          //   console.log('Parameters:', JSON.stringify(params, null, 2));
        })
        .catch((error) => {
          //     console.error('❌ Analytics event error:', error);
        });
    } catch (error) {
      //   console.error('❌ Analytics event error:', error);
    }
  }
}
